import React from "react";

const Poster = () => {

    return (
        <>
            <div class="main-poster" id="poster">
                <div class="psr-inner">
                    <div class="img-poster">
                        <img src="../assets/img/kd.jpg" alt="poster" />
                    </div>
                    <div class="container">
                        <div class="poster-text" data-aos="fade-down">
                            <div class="poster-text-inner">
                                <span class="span">ESTD 2012</span>
                                <h1>Dan Halsman</h1>
                                <span>Photographer</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
export default Poster;